import { Box, Button, Grid, Stack } from '@mui/material'
import React from 'react'
import image from  'assets/images/pagenotfound.svg'
import { useNavigate } from 'react-router'

const PageNotFound=()=> {
    const Nav=useNavigate()
  return (
    <Grid container justifyContent='center'>
        <Grid item xl={6} lg={6} justifyContent='center' alignItems='center'>
            <Box>
                <Stack>
                    <img src={image} alt='img' style={{aspectRatio:'16/9',width:'100%'}}/>
                    <Grid container justifyContent='center'>
                    <Grid item xl={4} lg={4} mt={1}>
                        <Button onClick={()=>Nav("/dashboard/default")} variant='contained' color='secondary' fullWidth>Go back to home</Button>
                    </Grid>
                    </Grid>
                </Stack>
            </Box>
        </Grid>
    </Grid>
  )
}

export default PageNotFound